import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { mcpOauthPendingConnection } from 'libs/mcpOauthPendingConnection'

interface McpConnectResumeState {
  saveUserActivityLog?: {
    action?: string
  }
}

const OAUTH_CONNECT_PATHNAME = '/oauth/connect/'

export default function useMcpConnectResume() {
  const history = useHistory<McpConnectResumeState>()
  const location = useLocation<McpConnectResumeState>()

  useEffect(() => {
    if (location.state?.saveUserActivityLog?.action !== 'signed_in') {
      return
    }

    if (location.pathname === OAUTH_CONNECT_PATHNAME) {
      return
    }

    if (!mcpOauthPendingConnection.read()) {
      return
    }

    history.replace(OAUTH_CONNECT_PATHNAME, location.state)
  }, [history, location])
}



// WEBPACK FOOTER //
// ./src/hooks/useMcpConnectResume/index.ts